/**
 * Created by yibrahim on 20/07/2017.
 */
import {GuestCredit} from './guest-credit';

export class Reservation {
  constructor(public pnr: string = null,
              public wviBookingId: string = null,
              public guestCredits: Array<GuestCredit> = null)
  {}
}



// WEBPACK FOOTER //
// ./src/app/shared/models/reservation.ts